export const colorPrimary = '#1AC073'    //green
export const colorSecondary = ' #F3BA00' //yellow
export const colorTertiary = '#F20505'   //red
export const colorWhite = '#FFFFFF'
export const colorGrey = '#E5E5E5'     
export const colorBlack = '#000000'